(function () {
  'use strict';

  var STORAGE_KEY = 'dn_selected_store';
  var stores = [];
  var dataEl = document.getElementById('dn-store-data');

  if (dataEl) {
    try {
      stores = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('DN store data could not be parsed:', e);
    }
  }

  function getSavedStore() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function saveStore(slug) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ slug: slug, ts: Date.now() }));
    } catch (e) {
      /* localStorage unavailable, fall back to in-memory only for this page view */
    }
  }

  function findStore(slug) {
    for (var i = 0; i < stores.length; i++) {
      if (stores[i].slug === slug) return stores[i];
    }
    return null;
  }

  function applyStoreToPage(store) {
    if (!store) return;

    document.querySelectorAll('[data-dn-instacart-link]').forEach(function (el) {
      el.setAttribute('href', store.instacart_link);
    });
    document.querySelectorAll('[data-dn-directions-link]').forEach(function (el) {
      el.setAttribute('href', store.directions_link);
    });
    document.querySelectorAll('[data-dn-store-link]').forEach(function (el) {
      if (store.page_url) el.setAttribute('href', store.page_url);
    });
    document.querySelectorAll('[data-dn-store-name]').forEach(function (el) {
      el.textContent = store.name;
    });
    document.querySelectorAll('[data-dn-store-address]').forEach(function (el) {
      el.textContent = store.address;
    });

    // Highlight matching card in the store locator section, if present
    document.querySelectorAll('[data-dn-locator-card]').forEach(function (el) {
      el.classList.toggle('dn-locator__card--active', el.getAttribute('data-dn-locator-card') === store.slug);
    });

    // Move the selected store's card to the front of any locator grid on the
    // page, keeping the rest in their existing (geographic) order.
    document.querySelectorAll('.dn-locator__grid').forEach(function (grid) {
      var card = grid.querySelector('[data-dn-locator-card="' + store.slug + '"]');
      if (card && grid.firstElementChild !== card) {
        grid.insertBefore(card, grid.firstElementChild);
      }
    });

    document.dispatchEvent(new CustomEvent('dn:store-changed', { detail: store }));
  }

  function selectStore(slug) {
    var store = findStore(slug);
    if (!store) return;
    saveStore(slug);
    applyStoreToPage(store);
  }

  window.dnSelectStore = selectStore; // exposed for inline onclick handlers (locator "Make this my store", store-select-modal)

  // --- Init ---

  document.addEventListener('DOMContentLoaded', function () {
    if (!stores.length) return;

    var saved = getSavedStore();
    if (saved && findStore(saved.slug)) {
      applyStoreToPage(findStore(saved.slug));
      return;
    }

    // No saved selection. Fall back to the default store rather than leaving the
    // page generic — the markup was already rendered with this store server-side
    // (snippets/dn-default-store.liquid), so applying it here changes no text or
    // href and cannot shift the layout. It only syncs the JS-driven bits, such as
    // the locator card highlight.
    //
    // Deliberately NOT saved: the visitor has not chosen anything, and writing it
    // would make a rendering default indistinguishable from a real preference.
    // Only window.dnSelectStore persists.
    var fallbackSlug = dataEl && dataEl.getAttribute('data-dn-default-store');
    var fallback = fallbackSlug ? findStore(fallbackSlug) : null;
    applyStoreToPage(fallback || stores[0]);
  });
})();
